<template>
    <div>
      <div class="content" style="margin: 10px;padding: 10px;">
        <div class="SearchBar">
          <el-form :inline="true" class="searchBoxForm">
            <el-form-item label="安检周期">
              <el-select
                  v-model="pageParams.periodId"
                  placeholder="请选择"
                  size="mini"
                  clearable
                  filterable
                  style="width: 180px;"
                  
              >
              <!-- @change="search" -->
                <el-option
                    v-for="(item, index) in userTypeList"
                    :key="index"
                    :label="item.periodName"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="安检员" class="searchItem">
              <el-select
                  clearable
                  filterable
                  v-model="pageParams.inspectorId"
                  placeholder="请选择"
                  size="mini"
                  style="width: 180px;"
              >
                <el-option
                    v-for="(item, index) in peopleList"
                    :key="index"
                    :label="item.realname"
                    :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          
         
            <el-form-item label="" class="searchItems">
               <el-button type="primary" @click="search" size="mini" >查询</el-button>
               <el-button type="warning" @click="restSearch" size="mini" >重置</el-button>
            </el-form-item>
          </el-form>
        </div>
          <el-table
              ref="tableData"
              :data="tableData"
              style="width: 100%;"
              border
              :header-cell-style="{
                              color: '#333',
                              fontFamily: 'MicrosoftYaHeiUI',
                              fontSize: '14px',
                              fontWeight: 900,
                              textAlign: 'left',
                              background: '#f8f8f9',
                          }"
              height="calc(100vh - 310px)"
              :stripe="true"
            >
            <el-table-column
              type="index"
              label="序号"
              width="50"
            >
            </el-table-column>
            <el-table-column
              prop="periodName"
              label="安检周期"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="inspectorName"
              label="安检员"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="messageCount"
              label="发送短信次数"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
          <el-pagination
          background
          layout="total, prev, pager, next,sizes, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageParams.current"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageParams.size"
        >
        </el-pagination>
      </div>
    </div>
  </template>
  
  <script>
  import { arumMessageStatic} from "../../RequestPort/staticisc";
  import { periodList  } from "../../RequestPort/selectQuery/residentRequest";
  import {inspectorDropDown} from "@/RequestPort/selectQuery/select";
  export default {
    name: 'userList',
    data() {
      return {
        userTypeList:[],
        peopleList:[],
        pageParams: {
            periodId:'',
          inspectorId:'',
          current: 1,
          size: 10,
        }, //  分页查询参数
        total:null,
        tableData: [], //  表格数据
        title:''
      };
    },
    mounted() {
        periodList().then(res=>{
        this.userTypeList = res.data
      })
      inspectorDropDown().then(res=>{
        this.peopleList = res.data
      })
      this.loadList(this.pageParams);
    },
    methods: {
      search() {
        this.pageParams.current = 1;
        this.loadList(this.pageParams);
      },
      restSearch() {
        this.pageParams = {
          userType:'',
          userId:'',
          status:'',
          addrId:'',
          keyWord:1,
          keyWordValue:'',
          current: 1,
          size: 10,
        };
        this.loadList(this.pageParams);
      },
      loadList(obj){
        arumMessageStatic(obj).then(res=>{
            console.log(res)
          this.tableData = res.data.records
          this.total = res.data.total
        })
      },
      handleCurrentChange(current) {
        this.pageParams.current = current;
        this.loadList(this.pageParams);
      },
      handleSizeChange(val) {
        this.pageParams.size = val;
        this.handleCurrentChange(1);
      },
      //跳转
      goPath(path, id, disable) {
        this.$router.push({ path: path, query: { id: id, disable: disable } })
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .searchBox {
    .searchBoxForm {
      display: flex;
      align-items: center;
    }
  }
  .tableTool{
    height: 25px;
  }
  .searchItem {
    margin-bottom: 1%;
  }
  .label {
    color: #909399;
  }
  .content-item {
    color: #444444;
  }
  .SearchBar {
    border-radius: 5px;
    background-color: #ffffff;
  }
  .content {
    background: #fff;
    width: 100%;
    border-radius: 6px;
    overflow:auto;
    height: calc(100vh - 200px);
  }
  .search{
    width: 190px;
  }
  .contain{
    height: 595px;
  }
  </style>
  
  
